import styled from '@emotion/styled'
import { ExtranetContainer, MediaQuery, useLanguage } from '@pharmac-extranet/shared'
import { PharmacButton, PharmacH1, PharmacH4, PharmacMainLogoMono, PharmacText } from '@pharmac/ui'
import { useEffect, useState } from 'react'
import { ExtranetWrapper } from '../../components/extranet/ExtranetWrapper'
import { EXTRANET_INACTIVITY_TIMESTAMP_STORAGE_KEY } from '../../components/inactivity-modal/InactivityModal'
import { useAuthenticationContext } from '../../features/authentication/useAuthentication'
import { EXTRANET_CUSTOMERSHIP_STORAGE_KEY } from '../../features/customer/CustomerProvider'

const ViewRoot = styled(ExtranetContainer)`
  background: linear-gradient(130.84deg, rgba(136, 40, 143, 0.83) 65.47%, #66d0d5 99.95%);

  height: 100%;
  position: relative;

  ${MediaQuery.maxTablet} {
    width: 100%;
    padding: 0 var(--spacing-large);
  }
`

const LogoContainer = styled.div`
  position: absolute;
  bottom: 50px;
  right: 50px;
`

export const ExpiredInviteLinkView = () => {
  const { t } = useLanguage()

  const { doLogout, user } = useAuthenticationContext()
  const [done, setDone] = useState<boolean>(false)

  useEffect(() => {
    if (user) {
      window.localStorage.removeItem(EXTRANET_CUSTOMERSHIP_STORAGE_KEY)
      window.localStorage.removeItem(EXTRANET_INACTIVITY_TIMESTAMP_STORAGE_KEY)

      doLogout({ redirectUri: window.location.href }).then(() => {
        setDone(true)
      })
    }
  }, [])

  if (!done)
    return (
      <ViewRoot
        full
        flexColumn
        alignCenter
        justifyCenter
      >
        <ExtranetWrapper>
          <PharmacH1
            marginLargeTop
            color="white"
          >
            {t('extranet:inviteLinks.inviteLinkExpired')}
          </PharmacH1>
          <PharmacH4
            marginMediumTop
            color="white"
          >
            {t('extranet:inviteLinks.inviteLinkAskNew')}
          </PharmacH4>
          <a href="/">
            <PharmacButton
              marginLargeVertical
              fullWidth
            >
              <PharmacText
                paddingSmall
                style={{ fontSize: '24px' }}
              >
                {t('extranet:inviteLinks.toSignin')}
              </PharmacText>
            </PharmacButton>
          </a>
        </ExtranetWrapper>
        <LogoContainer>
          <PharmacMainLogoMono
            width="250px"
            color="white"
          />
        </LogoContainer>
      </ViewRoot>
    )
}
